import React from 'react';
import './styles.css';
import BasicControlGroup from '../../../BasicControlGroup';
import LinkButton from '../../../LinkButton';

const EmailRequirementsItem = props => {
  const {
    data: { Name, Active, ProcessEmailSetupReqID, disabled = false },
    actions,
  } = props;

  const { onEdit, onRemove, onView } = actions;

  const handleViewRequirement = () => {
    !disabled && onView(ProcessEmailSetupReqID);
  };

  const handleEditRequirement = () => {
    !disabled && onEdit(ProcessEmailSetupReqID);
  };

  const handleDeleteRequirement = () => {
    !disabled && onRemove(ProcessEmailSetupReqID);
  };

  return (
    <div className="email-requirements__item">
      <div
        className={
          Active === 'Yes'
            ? 'email-requirements__name'
            : 'email-requirements__name email-requirements__name--inactive'
        }
      >
        {Name}
      </div>

      <div className="email-requirements__controls">
        <BasicControlGroup>
          {onView && (
            <LinkButton text="View" controlFunc={handleViewRequirement} />
          )}

          {onEdit && (
            <LinkButton text="Edit" controlFunc={handleEditRequirement} />
          )}

          {onRemove && (
            <LinkButton text="Delete" controlFunc={handleDeleteRequirement} />
          )}
        </BasicControlGroup>
      </div>
    </div>
  );
};

export default EmailRequirementsItem;
